<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-md-12 pt-2">
        <div class="text-center">
          <small class="text-muted">Chat iniciado em 07/11/2023 às 18:00 via Whatapp <i class="fas fa-sort-down"></i></small>
        </div>
        <div style="position: relative; display: block; width: 100%; min-height: 390px;">
          <div style="border: solid 1px #efefef;width: 100%; min-height: 380px; border-radius: 7px; background-color: #f9fcfd;">
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 pt-2">
        <div style="position: relative; bottom: 10px; display: block;">
          <b-card class="text-left pb-2" style="max-width: 100%">
            <div class="pb-2">
              <span class="text-third" style="border-bottom: solid 1 px #006a5b;">Mensagem</span>
              <span>&nbsp; | &nbsp;</span>
              <span>Observações interna</span>
            </div>
            <b-form-textarea
              id="textarea"
              v-model="message"
              placeholder="Digite aqui sua mensagem..."
              rows="3"
              max-rows="6"
            ></b-form-textarea>
            <template #footer>
              <div>
                <span class="pr-4">
                  <b-button v-b-popover.hover.top="'Clique para visualiza as ações!'" title="Ações">
                    <i class="fas fa-bolt text-warning"></i>
                  </b-button>
                </span>
                <span class="pr-4">
                  <i class="fas fa-paperclip text-third"></i>
                </span>
                <span class="pr-4">
                  <i class="fas fa-smile text-third"></i>
                </span>
                <span class="pr-4">
                  <i class="fas fa-sms text-third"></i>
                </span>
                <span class="pr-4">
                  <i class="fas fa-phone-volume text-third"></i>
                </span>
                <span style="display: block; position: absolute; right: 30px; bottom: 25px; cursor: pointer;">
                  <i class="fas fa-play text-third"></i>
                </span>
              </div>
            </template>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AtendimentoChat',
  data () {
    return {
      message: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/chat.vue